export default __webpack_public_path__ + "3f84183ce9df2319dd8b9e25e879eca9.woff2";